import { __rest } from "tslib";
import * as React from 'react';
import { st, classes } from './SocialBarIcon.st.css';
import { Tooltip } from '../Tooltip';
import { TPAComponentsConsumer } from '../../../../esm/components/TPAComponentsConfig';
import { IconButton, IconButtonSkins } from '../IconButton';
class SocialBarIcon extends React.Component {
    render() {
        const _a = this.props, { children, tooltip, socialBarTheme, className } = _a, rest = __rest(_a, ["children", "tooltip", "socialBarTheme", "className"]);
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile }) => (React.createElement("div", { className: st(classes.root, { theme: socialBarTheme }, className) },
            React.createElement(Tooltip, { appendTo: "scrollParent", content: tooltip, placement: "top", disabled: !tooltip || mobile },
                React.createElement(IconButton, Object.assign({ className: classes.iconButton, skin: IconButtonSkins.Full, as: "a" }, rest)))))));
    }
}
SocialBarIcon.defaultProps = { socialBarTheme: 'light' };
export { SocialBarIcon };
//# sourceMappingURL=SocialBarIcon.js.map